document.addEventListener('DOMContentLoaded', () => {
  const lightbox = document.querySelector('.lightbox');
  const lbBackdrop = lightbox.querySelector('.lightbox-backdrop');
  const lbClose = lightbox.querySelector('.lightbox-close');
  const lbImage = lightbox.querySelector('.lightbox-image');
  const lbCaption = lightbox.querySelector('.lightbox-caption');
  const triggers = document.querySelectorAll('.lightbox-trigger');

  function openLightbox(url, caption, alt) {
    lbImage.src = url;
    lbImage.alt = alt || '';
    // lbCaption.textContent = caption || '';
    lightbox.classList.add('active');
    lightbox.setAttribute('aria-hidden', 'false');
  }

  function closeLightbox() {
    lightbox.classList.remove('active');
    lightbox.setAttribute('aria-hidden', 'true');
    lbImage.src = '';
    lbCaption.textContent = '';
  }

  triggers.forEach(trigger => {
    trigger.addEventListener('click', event => {
      event.preventDefault();
      const url = trigger.dataset.fullUrl;
      const caption = trigger.dataset.caption;
      const alt = trigger.querySelector('img').alt;
      openLightbox(url, caption, alt);
    });
  });

  lbBackdrop.addEventListener('click', closeLightbox);
  lbClose.addEventListener('click', closeLightbox);

  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && lightbox.classList.contains('active')) {
      closeLightbox();
    }
  });
});
